import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LaTooltipComponent} from './la-tooltip.component';
import {LaTextModule} from '..';

@NgModule({
  imports: [
    CommonModule,
    LaTextModule
  ],
  declarations: [LaTooltipComponent],
  exports: [LaTooltipComponent]
})
export class LaTooltipModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaTooltipModule,
      providers: []
    };
  }
}
